define('views/modules/setting/business/payment/payment-informations-form',[
    // Libs
    "underscore",
    "backbone",
    "mustache",
    "moment",
    "bootbox",
    "utils",
    "services/i18n",
    // views
    "views/parts/info-section",
    "views/parts/form/textbox",
    "views/parts/form/select",
    // templates
    "text!templates/modules/setting/business/payment/payment-informations-form.html",
], function (
    // Libs
    _,
    Backbone,
    Mustache,
    moment,
    Bootbox,
    U,
    i18n,
    // views
    VInfoSection,
    VTextBox,
    VSelect,
    // templates
    TPaymentInformationsForm
) {
    var VPaymentInformationsForm = Backbone.Epoxy.View.extend({
        template: TPaymentInformationsForm,

        regions: {
            loading: ".loading-dots",
            vaultedCard: ".vaulted-card-section",
            formElement: ".card-form",
            form: {
                cardNumber: ".card-number-input",
                cardType: ".card-type-input",
                cardOwner: ".card-owner-input",
                expiryMonth: ".card-expiry-month-input",
                expiryYear: ".card-expiry-year-input",
                securityCode: ".security-code-input",
            },
        },

        displayState: {
            LOADING: 0,
            NEW_CARD_FORM: 1,
            VAULTED_CARD: 2,
        },

        defaults: {
            cardTypeOptions: ["Visa", "MasterCard"],
            monthOptions: [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12",
            ],
            yearOptions: Array.apply(null, { length: 20 }).map(function (x, i) {
                return moment().year() + i;
            }),
        },

        initialize: function (opt) {
            this.options = opt = opt || {};

            this.currentDisplayState = this.displayState.LOADING;
            this.view = {
                info: new VInfoSection({
                    title: "payment:your_credit_card_information",
                    content: this.template,
                }),
                form: {
                    cardNumber: new VTextBox({
                        model: this.options.model,
                        attribute: "cardNumber",
                        label: "payment:card_number",
                        labelposition: "top",
                        validation: true,
                        validationMsg: "payment:error_card_number_invalid",
                    }),
                    cardType: new VSelect({
                        model: this.options.model,
                        attribute: "cardType",
                        label: "payment:card_type",
                        labelposition: "top",
                        collection: this.defaults.cardTypeOptions,
                        validation: true,
                        skipTranslation: true,
                    }),
                    expiryMonth: new VSelect({
                        model: this.options.model,
                        attribute: "expirationMonth",
                        label: "payment:card_expiration",
                        labelposition: "top",
                        title: i18n.t("payment:card_expiration_month"),
                        collection: this.defaults.monthOptions,
                        validation: true,
                        skipTranslation: true,
                        validationMsg:
                            "payment:error_card_expiration_month_blank",
                    }),
                    expiryYear: new VSelect({
                        model: this.options.model,
                        attribute: "expirationYear",
                        label: " ",
                        labelposition: "top",
                        title: i18n.t("payment:card_expiration_year"),
                        collection: this.defaults.yearOptions,
                        validation: true,
                        skipTranslation: true,
                        validationMsg:
                            "payment:error_card_expiration_year_blank",
                    }),
                    securityCode: new VTextBox({
                        model: this.options.model,
                        attribute: "securityCode",
                        label: "payment:card_security",
                        labelposition: "top",
                        validation: true,
                        validationMsg: "payment:error_card_cvv_blank",
                    }),
                },
            };
        },

        render: function () {
            var html = Mustache.render(this.template, Mustache.getContext());

            this.assign(this.view.info, this.$el) // must be first
                .generateZones();

            var view = this.view,
                zone = this.zone;

            this.assign(view.form.cardNumber, zone.form.$cardNumber)
                .assign(view.form.cardType, zone.form.$cardType)
                .assign(view.form.expiryMonth, zone.form.$expiryMonth)
                .assign(view.form.expiryYear, zone.form.$expiryYear)
                .assign(view.form.securityCode, zone.form.$securityCode);

            //Set initial value
            this.view.form.cardType.selectFirstOption();

            return this;
        },

        getCardOwner: function () {
            return this.view.form.cardOwner.getValue();
        },

        resetFieldsState: function () {
            var form = this.view.form;

            form.cardNumber.clearError();
            form.cardType.clearError();
            form.expiryMonth.clearError();
            form.expiryYear.clearError();
            form.securityCode.clearError();
        },

        toggleDisplay: function (isCreditCardPayment) {
            this.$el.toggleClass("hidden", !isCreditCardPayment);
        },
    });

    return VPaymentInformationsForm;
});

